// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3731":"460c4421","4548":"c38fef53","12752":"460c4421","32622":"460c4421","42396":"80b81a22","63238":"f96ef282"}[chunkId] + ".chunk.css";
};